import { useEffect, useRef } from 'react';

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
export const turnstileEnabled = Boolean(SITE_KEY);

let scriptPromise = null;
const loadScript = () => {
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve) => {
      if (window.turnstile) return resolve();
      const s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = resolve;
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
};

export const TurnstileWidget = ({ onVerify }) => {
  const ref = useRef(null);
  const widgetId = useRef(null);
  const cbRef = useRef(onVerify);
  cbRef.current = onVerify;

  useEffect(() => {
    if (!SITE_KEY) return;
    let mounted = true;
    loadScript().then(() => {
      if (!mounted || !ref.current || widgetId.current !== null) return;
      widgetId.current = window.turnstile.render(ref.current, {
        sitekey: SITE_KEY,
        callback: (token) => cbRef.current(token),
        'expired-callback': () => cbRef.current(null),
        'error-callback': () => cbRef.current(null),
        theme: 'light',
      });
    });
    return () => {
      mounted = false;
      if (widgetId.current !== null && window.turnstile) {
        try { window.turnstile.remove(widgetId.current); } catch (e) {}
        widgetId.current = null;
      }
    };
  }, []);

  if (!SITE_KEY) return null;
  return <div ref={ref} data-testid="turnstile-widget" className="flex justify-center" />;
};
